export class localStorageVariables{
  public static readonly LastCompletedStepPageName= "LastCompletedStepPageName";
  public static readonly ActiveStepPageName= "ActiveStepPageName";
  public static readonly MenuWorkflowStep = "MenuWorkflowStep"; // Tracks menu workflow progression (major milestones)
  public static readonly PropertyId="PropertyId";    
  public static readonly sitename= "sitename";
  public static readonly Property= "Property";
  public static readonly customtheme="customtheme";
  public static readonly PropertyBannerImageUrl= "PropertyBannerImageUrl";
  public static readonly PropertyLogoUrl= "PropertyLogoUrl";
  public static readonly SelectedUnitID="SelectedUnitID"
  public static readonly isOnlineLeasingIDVerifyEnabled="isOnlineLeasingIDVerifyEnabled"
  public static readonly enableUploadID = "enableUploadID"
  public static readonly PropertyName="PropertyName"
  public static readonly SelectedMoveInDate="SelectedMoveInDate"
  public static readonly FloorPlanID="FloorPlanID"
  public static readonly FloorPlanName="FloorPlanName"
  public static readonly SelectedBedCount="SelectedBedCount"
  public static readonly SelectedBathCount="SelectedBathCount"
  public static readonly SelectedArea="SelectedArea"
  public static readonly SelectedAreaDisplay="SelectedAreaDisplay" 
  public static readonly SelectedUnitCode="SelectedUnitCode"
  public static readonly SelectedRoomCode="SelectedRoomCode"
  public static readonly PrimaryApplicantId="PrimaryApplicantId"
  public static readonly isPrimaryApplicantLogin="isPrimaryApplicantLogin"
  public static readonly LoginApplicantId="LoginApplicantId"
  public static readonly lastUrlBeforeLogin="lastUrlBeforeLogin"
  public static readonly workflowStep="workflowStep"
  public static readonly Profiles="Profiles"
  public static readonly ApplicantProfiles="ApplicantProfiles"
  public static readonly AccountsCallingSource="AccountsCallingSource"
  public static readonly TemplastUrlBeforeLogin="TemplastUrlBeforeLogin"
  public static readonly ElevateSession="ElevateSession"
  public static readonly TemplateId="TemplateId"
  public static readonly IsApplyByUnit="IsApplyByUnit"
  public static readonly WebsiteUrl="WebsiteUrl"
  public static readonly EncPropertyId = "EncPropertyId"
  public static readonly EncProspectId = "EncProspectId"
  public static readonly EncGuarantorId = "EncGuarantorId"
  public static readonly EncPmUserExId = "EncPmUserExId"
  public static readonly EncPrimaryProspectId = "EncPrimaryProspectId"
  public static readonly NextStepPageName = "NextStepPageName"
  public static readonly IsGuarantor = "IsGuarantor"
  public static readonly PreviousStepPageName = "PreviousStepPageName"
  public static readonly IsGuarantorIDVerifyEnabled="IsGuarantorIDVerifyEnabled"
  public static readonly IsScreeningEnabled="IsScreeningEnabled"
  public static readonly IsAcceptResponsibilityEnabled="IsAcceptResponsibilityEnabled"
  public static readonly CachedThemeCSS = "CachedThemeCSS";
  public static readonly CachedThemeCSSExpiry = "CachedThemeCSSExpiry";
  public static readonly AllGuarantee = "AllGuarantee";//TR#808940-Future
}
